<template>
    <div class="container margin_80_55">
      <div class="row  mt-5">
        <div class="col-lg-9" v-if="newsInfo">
          <div class="bloglist singlepost">
            <h1>{{ newsInfo.Title }}</h1>
            <div class="postmeta">
              <ul>
                <li>
                  <i class="icon_clock_alt"></i>
                  {{
                    new Date(newsInfo.UpdateDate)
                      .toLocaleString()
                      .replace(",", "")
                      .replace(/:.. /, " ")
                  }}
                </li>
                <li>
                  <i class="icon_pencil-edit"></i>
                  {{ newsInfo.UserName }}
                </li>
              </ul>
            </div>
            <!-- /post meta -->
            <div class="post-content">
              <div class="dropcaps">
                <p v-html="newsInfo.Body"></p>
              </div>
            </div>
            <!-- /post -->
          </div>
          <!-- /single-post -->
        </div>
        <!-- /col -->
  
        <aside class="col-lg-3 bg-white h-100" >
          <!-- /widget -->
          <div class="widget">
            <div class="widget-title">
              <h4>Recent Posts</h4>
            </div>
            <ul class="comments-list" v-if="newslist">
              <li  v-for="(newslistitem, index) in newslist"
              :key="index">
                
                <small>{{ newslistitem.UserName }}</small>
                <h3>
                    <a href="javascript:void(0)" @click="reloadToDetailsPg(newslistitem.ID)"> {{ newslistitem.Title }}</a>
                  
                  <!-- <router-link
                    :to="{
                      name: 'BlogDetails',
                      params: { blogId: bloglistitem.ID },
                    }"
                    >{{ bloglistitem.Title }}</router-link
                  > -->
                </h3>
              </li>
            </ul>
          </div>
  
          <!-- /widget -->
          <!-- <div class="widget">
            <div class="widget-title">
              <h4>Popular Tags</h4>
            </div>
            <div class="tags">
              <a href="#">Information tecnology</a>
              <a href="#">Students</a>
              <a href="#">Community</a>
              <a href="#">Carreers</a>
              <a href="#">Literature</a>
              <a href="#">Seminars</a>
            </div>
          </div> -->
          <!-- /widget -->
        </aside>
        <!-- /aside -->
      </div>
      <!-- /row -->
    </div>
  </template>
<script>
import NewsService from '../services/news.service'
import _ from 'lodash'
export default {
  name: 'NewsDetails',
  data() {
    return {
      newsInfo: [],
      newslist: [],
    }
  },
  watch: {
    $route () {
      this.getNewsInfo(this.$route.params.Id)
    }
  },
  mounted() {
    this.getNewsInfo(this.$route.params.Id)
    this.getNews()
  },
  methods: {
    getNewsInfo(Id) {
      NewsService.getNewsInformation(Id).then((response) => {
        this.newsInfo = response.data.Object.newsAndPress
      }),
      (error) => {
        console.log(error)
      }
    },
    getNews() {
      NewsService.getNewsList().then((response) => {
        this.newslist = _.orderBy(response.data.Object.newsList).slice(0, 3)
      }),
      (error) => {
        console.log(error)
      }
    },
    reloadToDetailsPg(blogId){
      this.$router.push({ name: 'NewsDetails', params: { Id: blogId } }, )
      this.getNewsInfo(blogId)
    }
  },
}
</script>
  